import { AlertTitle as MuiAlertTitle, AlertTitleProps as MuiAlertTitleProps } from '@mui/material';

export const AlertTitle = MuiAlertTitle;
export type AlertTitleProps = MuiAlertTitleProps;
